import { Avatar, Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Grid, IconButton, LinearProgress, List, ListItem, ListItemAvatar, ListItemText, Typography } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import Parcel from "../../models/Parcel";
import $data from "../../services/$data";
import { variables } from "../../styles/abstract/variables";
import { DataContext } from "../DataContext";
import SelectInput from "../ui/SelectInput";
import TextInput from "../ui/TextInput";
import WKT from 'ol/format/WKT';
import { AppContext } from "../../AppContext";
import WidgetDescription from "../widgets/WidgetDescription";
import moment from "moment";
import { Add, Close, Delete } from "@mui/icons-material";

import olives from '../../images/olives-picked.webp';
import almonds from '../../images/almonds.webp';

function AddParcelModal(props) {
	const { user ,selected} = useContext(AppContext);
	const { projectData, onShowSuccess } = useContext(DataContext);

	const [loading, setLoading] = useState(false);


	const [state, setState] = useState({
		name: '',
		history: []
	});

	const [historyState, setHistoryState] = useState({
		biomass: '',
		year: '',
		yield: '',
		number_of_trees: '',
		crop: ''
	});

	const [status, setStatus] = useState({
		error: {},
		success: null,
	});

	const generateYears = () => {
		let initialVal = moment().format('YYYY');
		let arr = [];
		for (let i = 0; i < 50; i++) {

			if (i === 0) {
				arr.push({ value: initialVal, label: initialVal.toString() })
			}

			initialVal = moment(initialVal).subtract(1, 'years').format('YYYY');
			arr.push({ value: initialVal, label: initialVal.toString() })
		}
		return arr
	}

	const onSubmit = async () => {
		setLoading(true);

		try {

			let payload = {
				name: state.name,
				geometry: new WKT().writeFeature(props.feature),
				project_id: selected,
				med_crop_history: state.history
			}

			await $data.createParcel(payload)
			let parcels = await $data.getParcels(selected, user.user_type === 1);

			props.onAddParcel(parcels);
			onShowSuccess('Parcel successfully created')
			props.onClose();
		} catch (e) {
			console.log(e)
			setStatus({ ...status, error: e });
		} finally {
			setLoading(false);
		}
	}

	const renderHistory = () => {
		if (state.history.length === 0) {
			return <Typography sx={{ mb: '10px' }}>No history of replanting</Typography>
		}


		return <List dense>
			{
				state.history.map((item, index) => {
					return (
						<ListItem secondaryAction={<IconButton onClick={() => { setState(current => ({ ...current, history: current.history.filter((h, i) => i !== index) })) }}><Delete color="error" /></IconButton>} key={index}>
							<ListItemAvatar ><Avatar src={item.crop === 'Olives' ? olives : almonds} /></ListItemAvatar>
							<ListItemText primary={item.crop + (index === 0 ? ' (First Planting)' : '')} primaryTypographyProps={{ fontWeight: 'bold', color: 'primary' }} secondary={`${item.year} | Number of trees: ${item.number_of_trees} | Residues: ${item.biomass == 'burned' ? 'Burned' : 'Removed'} | Yield: ${item.yield} kg`}></ListItemText>
						</ListItem>
					)

				})
			}
		</List>
	}

	return (
		<Dialog disableEscapeKeyDown fullWidth maxWidth="md" PaperProps={{ className: 'co-background-white' }} open={props.open} onClose={props.onClose}>

			<DialogTitle color="primary">Create parcel</DialogTitle>
				<DialogContent>
					<form style={{marginTop: '30px'}} onSubmit={(evt) => { evt.preventDefault(); onSubmit() }}>
						<TextInput required value={state.name} error={Boolean(status.error.name)} helperText={status.error.name || null} onChange={(evt) => setState(current => ({ ...current, name: evt.target.value }))} label="Name" />
					</form>
					<>
						<Divider sx={{ mb: '20px' }} />
						<Typography color="primary" variant="h6">Crop Planting/Replanting</Typography>
						{renderHistory()}

						<Divider sx={{ mb: '10px' }} />
						<Grid container spacing={1}>
							<Grid item xs={12} sm={6}>
								<SelectInput required onChange={(evt) => { setHistoryState(current => ({ ...current, crop: evt.target.value })) }} value={historyState.crop} name={'Crop'} items={[{ value: 'Olives', label: 'Olives' }, { value: 'Almonds', label: 'Almonds' }]} />
							</Grid>
							<Grid item xs={12} sm={6}>
								<SelectInput required onChange={(evt) => { setHistoryState(current => ({ ...current, year: evt.target.value })) }} value={historyState.year} name={state.history.length > 0 ? 'Year of replanting' : 'Year of first plant'} items={generateYears()} />
							</Grid>
							<Grid item xs={12} sm={6}>
								<TextInput required type="number" value={historyState.number_of_trees} onChange={(evt) => setHistoryState(current => ({ ...current, number_of_trees: evt.target.value }))} label="Number of trees" />
							</Grid>
							<Grid item xs={12} sm={6}>
								<TextInput required type="number" value={historyState.yield} onChange={(evt) => setHistoryState(current => ({ ...current, yield: evt.target.value }))} label="Yield (kg)" />
							</Grid>
							<Grid item xs={12} sm={6}>
								<SelectInput required name="Residues/Biomass management" value={historyState.biomass} items={[{ value: 'burned', label: 'Burned and used as a fuel' }, { value: 'removed', label: 'Removed from the field and sold' }]} onChange={(evt) => setHistoryState(current => ({ ...current, biomass: evt.target.value }))} />
							</Grid>
							<Grid item xs={12} textAlign="center">
								<Button onClick={() => {
									setState(current => ({
										...current,
										history: [...current.history, { crop: historyState.crop, yield: historyState.yield, biomass: historyState.biomass, year: historyState.year, number_of_trees: historyState.number_of_trees }]
									}));
									setHistoryState(current => ({ ...current, number_of_trees: '', year: undefined, biomass: undefined, yield: '' }));
								}} size="small" variant="contained" startIcon={<Add />}>Add Planting/Replanting Record</Button>
							</Grid>
						</Grid>
					</>
					{status.error.constructor == Array &&
						<>
							<Divider sx={{ background: variables.dangerColor }} />
							<p className="co-danger" style={{ fontSize: '13px', fontWeight: 'bold' }}>{status.error}</p>
						</>
					}

				</DialogContent>
				<DialogActions>
					<Button disabled={loading} style={{ lineHeight: 'unset' }} color="error" onClick={props.onClose}>Cancel</Button>
					<Button disabled={loading || state.history.length === 0 || state.name === ''} onClick={onSubmit} style={{ lineHeight: 'unset' }} color="primary">Create</Button>

				</DialogActions>

				{loading && <LinearProgress color="primary" />}
		</Dialog>
	)
}

export default AddParcelModal;